import React from "react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  let getYear = () => {
    let currentYear = new Date().getFullYear();
    return currentYear;
  };
  return (
    <div>
      <footer className="bg-gray-900 dark:bg-gray-800">
        <div className="mx-auto w-full max-w-screen-xl p-4 py-6 lg:py-8">
          {/* <hr className="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" /> */}
          <div className="sm:flex sm:items-center sm:justify-between">
            <span className="text-md text-white sm:text-center font-Kalam">
              © 2023 SHYAM DEVAKUMARAN
            </span>
            <div className="flex mt-4  space-x-6 sm:justify-center sm:mt-0">
              <a
                href="https://www.behance.net/shyamdevakum"
                target="_blank"
                rel="noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="30"
                  height="30"
                  className="text-xl transition-colors text-white duration-200 hover:text-white dark:hover:text-white"
                  viewBox="0,0,255.9946,255.9946"
                >
                  <g
                    fill="#ffffff"
                    fill-rule="nonzero"
                    stroke="none"
                    stroke-width="1"
                    stroke-linecap="butt"
                    stroke-linejoin="miter"
                    stroke-miterlimit="10"
                    stroke-dasharray=""
                    stroke-dashoffset="0"
                    font-family="none"
                    font-weight="none"
                    font-size="none"
                    text-anchor="none"
                  >
                    <g transform="scale(5.12,5.12)">
                      <path d="M9,4c-2.74952,0 -5,2.25048 -5,5v32c0,2.74952 2.25048,5 5,5h32c2.74952,0 5,-2.25048 5,-5v-32c0,-2.74952 -2.25048,-5 -5,-5zM9,6h32c1.66848,0 3,1.33152 3,3v32c0,1.66848 -1.33152,3 -3,3h-32c-1.66848,0 -3,-1.33152 -3,-3v-32c0,-1.66848 1.33152,-3 3,-3zM11,16c-0.55226,0.00006 -0.99994,0.44774 -1,1v16.00195c0.00006,0.55226 0.44774,0.99994 1,1h7.60938c0.00065,0 0.0013,0 0.00195,0c0.41242,-0.00065 1.85909,-0.03581 3.35547,-0.73828c1.49633,-0.70247 3.0332,-2.28232 3.0332,-4.83594c0,-1.61999 -0.53053,-2.83986 -1.24219,-3.64258c-0.29784,-0.33595 -0.57608,-0.37359 -0.89062,-0.58008c0.60177,-0.70396 1.13281,-1.65669 1.13281,-3.20508c0,-2.38267 -1.30503,-3.8614 -2.64648,-4.46289c-1.34146,-0.60149 -2.72095,-0.53711 -3.06055,-0.53711zM30,16c-0.36064,-0.0051 -0.69608,0.18438 -0.87789,0.49587c-0.18181,0.3115 -0.18181,0.69676 0,1.00825c0.18181,0.3115 0.51725,0.50097 0.87789,0.49587h6c0.36064,0.0051 0.69608,-0.18438 0.87789,-0.49587c0.18181,-0.3115 0.18181,-0.69676 0,-1.00825c-0.18181,-0.3115 -0.51725,-0.50097 -0.87789,-0.49587zM12,18h6.29297c0.4524,0 1.42814,-0.0037 2.24219,0.36133c0.81404,0.36501 1.46484,0.88735 1.46484,2.63867c0,1.87589 -0.7229,2.23586 -1.15234,2.45703c-0.35558,0.18367 -0.56742,0.56163 -0.53852,0.9608c0.02891,0.39917 0.293,0.74267 0.67133,0.87319c0.37813,0.12962 0.88315,0.37128 1.28125,0.82031c0.3981,0.44903 0.73828,1.1074 0.73828,2.31641c0,1.83038 -0.84269,2.53711 -1.88281,3.02539c-1.04012,0.48828 -2.28624,0.54848 -2.50781,0.54883h-6.60937zM33,19c-0.91237,0 -2.58259,0.18126 -4.13672,1.24805c-1.55413,1.06679 -2.86328,3.09135 -2.86328,6.25195c0,2.9434 1.20884,4.94415 2.72852,6.06836c1.51967,1.1242 3.24217,1.43164 4.44141,1.43164c2.53915,0 4.33457,-0.86305 5.41016,-2.08984c0.99343,-1.13308 1.32229,-2.46985 1.37305,-3.61328c0.0272,-0.08476 0.04297,-0.17278 0.04688,-0.26172c0.00031,-0.0086 -0.00225,-0.0187 -0.00195,-0.02734c0.00005,-0.00245 0.00195,-0.00537 0.00195,-0.00781c-0.00029,-0.03328 -0.00225,-0.06652 -0.00586,-0.09961c0,-0.0013 0,-0.0026 0,-0.00391c0.05445,-1.80735 -0.08556,-3.89615 -1.05078,-5.68359c-0.98874,-1.831 -2.97679,-3.21289 -5.94336,-3.21289zM15,20v3h2.61914c0.357,0 1.54688,-0.22545 1.54688,-1.56445c0,-1.34 -1.54816,-1.43555 -1.78516,-1.43555zM33,21c2.40843,0 3.48288,0.86811 4.18164,2.16211c0.566,1.04814 0.73808,2.45623 0.77148,3.83789h-2.95312h-4c-0.55226,0.00006 -0.99994,0.44774 -1,1c0,0 0.0086,0.25241 0.08203,0.47266c0.07341,0.22024 0.21809,0.49152 0.46094,0.73438c0.4857,0.4857 1.29036,0.79297 2.45703,0.79297c1.16667,0 1.97133,-0.30727 2.45703,-0.79297c0.0686,-0.0686 0.07739,-0.13566 0.13086,-0.20703h2.25391c-0.13318,0.55475 -0.34711,1.1125 -0.76562,1.58984c-0.67791,0.77321 -1.7974,1.41016 -3.90625,1.41016c-0.82876,0 -2.19413,-0.25652 -3.25195,-1.03906c-1.05783,-0.78255 -1.91797,-2.03134 -1.91797,-4.46094c0,-2.6464 0.93048,-3.87205 1.99609,-4.60352c1.06562,-0.73146 2.39528,-0.89648 3.00391,-0.89648zM33.08594,22.60156c-0.591,0 -1.01552,0.07547 -1.35352,0.23047c-0.338,0.154 -0.58975,0.38714 -0.84375,0.61914c-0.169,0.232 -0.33883,0.46539 -0.42383,0.77539c-0.085,0.232 -0.16897,0.46439 -0.16797,0.77539h5.4082c-0.085,-0.775 -0.33872,-1.39425 -0.76172,-1.78125c-0.422,-0.387 -1.01242,-0.61914 -1.85742,-0.61914zM15.0332,26v3.98047h2.92969c0.254,0 2.03711,-0.09802 2.03711,-1.91602c0,-1.82 -1.40111,-2.06445 -2.03711,-2.06445z"></path>
                    </g>
                  </g>
                </svg>
              </a>

              <a
                href="mailto:shyamdeva080502@gmail.com"
                target="_blank"
                rel="noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="30"
                  height="30"
                  viewBox="0,0,255.9946,255.9946"
                >
                  <g
                    fill="#ffffff"
                    fillRule="nonzero"
                    stroke="none"
                    strokeWidth="1"
                    strokeLinecap="butt"
                    strokeLinejoin="miter"
                    strokeMiterlimit="10"
                    strokeDasharray=""
                    strokeDashoffset="0"
                    fontFamily="none"
                    fontWeight="none"
                    fontSize="none"
                    textAnchor="none"
                  >
                    <g transform="scale(5.12,5.12)">
                      <path d="M43.75391,6.40234c-1.2177,-0.05335 -2.45911,0.31055 -3.48242,1.06641l-2.74609,2.02734l-12.52539,9.25977l-12.4082,-9.17187c-0.17292,-0.16897 -0.4012,-0.26957 -0.64258,-0.2832h0.25l-2.46484,-1.82422c-1.02397,-0.75773 -2.26723,-1.12367 -3.48633,-1.07031c-1.2191,0.05336 -2.4131,0.52522 -3.33984,1.43945c-1.17726,1.16068 -1.9082,2.78413 -1.9082,4.56445v3.43359c-0.01457,0.09777 -0.01457,0.19715 0,0.29492v23.36133c0,1.92119 1.57881,3.5 3.5,3.5h7.5c0.55226,-0.00006 0.99994,-0.44774 1,-1v-16.62695l11.40625,8.43164c0.353,0.26043 0.8345,0.26043 1.1875,0l11.40625,-8.43164v16.62695c0.00006,0.55226 0.44774,0.99994 1,1h7.5c1.92119,0 3.5,-1.57881 3.5,-3.5v-23.38086c0.01129,-0.08622 0.01129,-0.17355 0,-0.25977v-3.44922c0,-1.75846 -0.70954,-3.37437 -1.87109,-4.53711c-0.03357,-0.03357 -0.04482,-0.04287 -0.03125,-0.0293c-0.00194,-0.00196 -0.0039,-0.00391 -0.00586,-0.00586c-0.92656,-0.91221 -2.12019,-1.3822 -3.33789,-1.43555zM43.64453,8.40039c0.7563,0.02965 1.48952,0.3165 2.04492,0.86328c0.01891,0.01867 0.03272,0.03277 0.02344,0.02344c0.79645,0.79726 1.28711,1.9015 1.28711,3.12305v3.08594l-8,5.91211v-10.4082c0.00042,-0.0339 -0.00088,-0.0678 -0.00391,-0.10156l2.46289,-1.82031c0.00065,0 0.0013,0 0.00195,0c0.64864,-0.47915 1.42729,-0.70739 2.18359,-0.67773zM6.35742,8.40625c0.75715,-0.02964 1.53847,0.19746 2.1875,0.67773l2.45898,1.81836c-0.00289,0.03247 -0.0042,0.06506 -0.00391,0.09766v10.4082l-8,-5.91211v-3.08594c0,-1.23567 0.50176,-2.3413 1.3125,-3.14062c0.55526,-0.54776 1.28777,-0.83364 2.04492,-0.86328zM37,12.37109v10.51563l-12,8.86914l-12,-8.86914v-10.51367l11.40625,8.43164c0.353,0.26043 0.8345,0.26043 1.1875,0zM3,17.98242l8,5.91406v17.10352h-6.5c-0.84081,0 -1.5,-0.65919 -1.5,-1.5zM47,17.98242v21.51758c0,0.84081 -0.65919,1.5 -1.5,1.5h-6.5v-17.10352z"></path>
                    </g>
                  </g>
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/in/Shyamdevakumaran/"
                target="_blank"
                rel="noreferrer"
              >
                <svg
                  width="30"
                  height="30"
                  fill="currentColor"
                  className="text-xl transition-colors text-white duration-200 hover:text-white dark:hover:text-white"
                  viewBox="0 0 1792 1792"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M477 625v991h-330v-991h330zm21-306q1 73-50.5 122t-135.5 49h-2q-82 0-132-49t-50-122q0-74 51.5-122.5t134.5-48.5 133 48.5 51 122.5zm1166 729v568h-329v-530q0-105-40.5-164.5t-126.5-59.5q-63 0-105.5 34.5t-63.5 85.5q-11 30-11 81v553h-329q2-399 2-647t-1-296l-1-48h329v144h-2q20-32 41-56t56.5-52 87-43.5 114.5-15.5q171 0 275 113.5t104 332.5z"></path>
                </svg>
              </a>
              <a
                href="https://github.com/ShyamDevakumaran"
                target="_blank"
                rel="noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  fill="currentColor"
                  className="text-xl transition-colors text-white duration-200 hover:text-white dark:hover:text-white"
                  viewBox="0 0 1792 1792"
                >
                  <path d="M896 128q209 0 385.5 103t279.5 279.5 103 385.5q0 251-146.5 451.5t-378.5 277.5q-27 5-40-7t-13-30q0-3 .5-76.5t.5-134.5q0-97-52-142 57-6 102.5-18t94-39 81-66.5 53-105 20.5-150.5q0-119-79-206 37-91-8-204-28-9-81 11t-92 44l-38 24q-93-26-192-26t-192 26q-16-11-42.5-27t-83.5-38.5-85-13.5q-45 113-8 204-79 87-79 206 0 85 20.5 150t52.5 105 80.5 67 94 39 102.5 18q-39 36-49 103-21 10-45 15t-57 5-65.5-21.5-55.5-62.5q-19-32-48.5-52t-49.5-24l-20-3q-21 0-29 4.5t-5 11.5 9 14 13 12l7 5q22 10 43.5 38t31.5 51l10 23q13 38 44 61.5t67 30 69.5 7 55.5-3.5l23-4q0 38 .5 88.5t.5 54.5q0 18-13 30t-40 7q-232-77-378.5-277.5t-146.5-451.5q0-209 103-385.5t279.5-279.5 385.5-103zm-477 1103q3-7-7-12-10-3-13 2-3 7 7 12 9 6 13-2zm31 34q7-5-2-16-10-9-16-3-7 5 2 16 10 10 16 3zm30 45q9-7 0-19-8-13-17-6-9 5 0 18t17 7zm42 42q8-8-4-19-12-12-20-3-9 8 4 19 12 12 20 3zm57 25q3-11-13-16-15-4-19 7t13 15q15 6 19-6zm63 5q0-13-17-11-16 0-16 11 0 13 17 11 16 0 16-11zm58-10q-2-11-18-9-16 3-14 15t18 8 14-14z"></path>
                </svg>
              </a>

              <a
                href="https://twitter.com/shyamdeva08?t=elbfFc8qERzAhe0zJtAR2Q&s=08"
                target="_blank"
                rel="noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="30"
                  height="30"
                  viewBox="0,0,255.9946,255.9946"
                >
                  <g
                    fill="#ffffff"
                    fill-rule="nonzero"
                    stroke="none"
                    stroke-width="1"
                    stroke-linecap="butt"
                    stroke-linejoin="miter"
                    stroke-miterlimit="10"
                    stroke-dasharray=""
                    stroke-dashoffset="0"
                    font-family="none"
                    font-weight="none"
                    font-size="none"
                    text-anchor="none"
                  >
                    <g transform="scale(5.12,5.12)">
                      <path d="M5.91992,6l14.66211,21.375l-14.35156,16.625h3.17969l12.57617,-14.57812l10,14.57813h12.01367l-15.31836,-22.33008l13.51758,-15.66992h-3.16992l-11.75391,13.61719l-9.3418,-13.61719zM9.7168,8h7.16406l23.32227,34h-7.16406z"></path>
                    </g>
                  </g>
                </svg>
              </a>

              
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
